<template>
  <div class="" v-if="isUserThisBroker || (!isUserThisBroker && broker != null)">

    <template v-if="!isUserThisBroker">
      &nbsp;&nbsp;&nbsp;
      <router-link :to="{ name: 'broker-list' }" tag="a" class="no-underline inline-block hover:underline mb-4 text-sm text-black">Back to broker list</router-link>
    </template>

    <div class="nav-box">

      <div class="nav-box-header">
        <template v-if="isUserThisBroker">
          My Settings
        </template>

        <template v-else>
          {{ broker.first_name }} {{ broker.last_name }}
        </template>
      </div>

      <router-link
        :to="{
          name: 'broker-account',
          params : {
            brokerId : $route.params.brokerId
          }
        }"
        tag="a"
        :class="{ 'nav-item mt-1' : true, 'selected' : $route.name == 'broker-account' }">
        <template v-if="isUserThisBroker">
          My Details
        </template>

        <template v-else>
          Broker Details
        </template>
      </router-link>

      <router-link
        :to="{
          name  : 'broker-password',
          params: {
            brokerId : $route.params.brokerId
          }
        }"
        tag="a"
        :class="{ 'nav-item' : true, 'selected' : $route.name == 'broker-password' }">Password</router-link>

      <router-link
        :to="{
          name  : 'broker-site-appearance',
          params: {
            brokerId : $route.params.brokerId
          }
        }"
        tag="a"
        :class="{ 'nav-item' : true, 'selected' : $route.name == 'broker-site-appearance' }">Site Appearance</router-link>

      <router-link
        :to="{
          name: 'broker-mail-setting',
          params: {
            brokerId: $route.params.brokerId
          }
        }"
        tag="a"
        :class="{ 'nav-item' : true, 'selected' : $route.name == 'broker-mail-setting' }">Mail Settings</router-link>

      <!-- broker payment can only be done by the broker -->
      <template v-if="$store.state[$store.state.view + 'Module'].broker.user_id == $store.state.user.id">
        <router-link
          :to="{
            name  : 'broker-payment',
            params: {
              brokerId : $route.params.brokerId
            }
          }"
          tag="a"
          :class="{ 'nav-item' : true, 'selected' : $route.name == 'broker-payment' }">Payment Details</router-link>
      </template>

      <router-link
        :to="{
          name  : 'broker-lead-capture',
          params: {
            brokerId : $route.params.brokerId
          }
        }"
        tag="a"
        :class="{ 'nav-item' : true, 'selected' : $route.name == 'broker-lead-capture' }">Lead Capture Form</router-link>

      <router-link
        :to="{
          name  : 'broker-template',
          params: {
            brokerId : $route.params.brokerId
          }
        }"
        tag="a"
        v-if="!$store.state[$store.state.view + 'Module'].broker.suspended"
        :class="{ 'nav-item mb-1' : true, 'selected' : $route.name == 'broker-template' }">Templates</router-link>
    </div>
  </div>
</template>

<script>
  export default {

    data() {
      return {
        broker : null
      }
    },

    created() {
      if(!this.isUserThisBroker) {
        this.showLoader("Getting data...")
        this.getBroker({
          brokerId: this.$route.params.brokerId,
          force   : true
        }, (broker) => {
          this.hideLoader()
          this.broker = broker
        })
      }
    },
  }
</script>